module.exports = __webpack_public_path__ + "img/DE00008.9103e83c.png";